export enum ViewType {
  DETAIL = "detail",
  SUMMARY = "summary"
}
